import { Button } from "@/components/ui/button"
import { Card, CardContent, CardHeader } from "@/components/ui/card"
import { TypographyH1, TypographyP } from "@/components/ui/typography"
import { useAutoTranslation, useUserStore } from "@/entities"
import { authControllerResendEmailCode } from "@/shared/api/generated"
import { LANG_KEYS, QUERY_KEYS } from "@/shared/constants"
import { SvgLogo } from "@/shared/ui/svg"
import { useMutation, useQueryClient } from "@tanstack/react-query"
import styles from "./styles.module.scss"

export const ConfirmEmailExpired = () => {
  const queryClient = useQueryClient()
  const email = useUserStore(s => s.email)
  const { t } = useAutoTranslation()

  const requestNewCodeMutation = useMutation({
    mutationFn: authControllerResendEmailCode,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: QUERY_KEYS.HAS_CODE })
    },
    onError: error => {
      console.error(error)
    },
  })

  return (
    <div className={styles.wrapper}>
      <SvgLogo className="h-16 w-16" variant="enhanced" />

      <div className={styles.inner}>
        <Card className={styles.card}>
          <CardHeader className="text-center">
            <TypographyH1>
              {t(LANG_KEYS.CONFIRMATION_CODE_EXPIRED)}
            </TypographyH1>
            <TypographyP>
              {t(
                LANG_KEYS.A_CONFIRMATION_CODE_HAS_EXPIRED_PLEASE_REQUEST_A_NEW_CODE
              )}
            </TypographyP>
            {email && <TypographyP>{email}</TypographyP>}
          </CardHeader>

          <CardContent>
            <div className={styles.footer}>
              <Button
                variant="outline"
                onClick={() => requestNewCodeMutation.mutate({})}
              >
                {t(LANG_KEYS.REQUEST_NEW_CODE)}
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  )
}
